import { createSelector } from 'reselect';
// feature customer-portal
import { initialState } from './reducer';
//////////////////////////////////////////////////

const store = (state) => state.customerPortal;

const makeSelectItemList = () => createSelector(
  store,
  ({ itemList }) => itemList,
);

const makeSelectTotalCount = () => createSelector(
  store,
  ({ totalCount }) => totalCount,
);

const makeSelectTableTitleFilters = () => createSelector(
  store,
  ({ tableTitleFilters }) => tableTitleFilters,
);

const makeSelectTitleSortValues = () => createSelector(
  store,
  ({ titleSortValues }) => titleSortValues,
);

const makeSelectPagination = () => createSelector(
  store,
  ({ pagination }) => pagination,
);

const makeSelectLocations = () => createSelector(
  store,
  ({ locations }) => locations,
);

const makeSelectMapOpened = () => createSelector(
  store,
  ({ mapOpened }) => mapOpened,
);

const makeSelectShowBooked = () => createSelector(
  store,
  ({ showBooked }) => showBooked,
);

const makeSelectReportStatus = () => createSelector(
  store,
  ({ reportPending }) => reportPending,
);

const makeSelectAvailableReports = () => createSelector(
  store,
  ({ availableReports }) => availableReports,
);

const makeSelectUsedReport = () => createSelector(
  store,
  ({ usedReport }) => usedReport,
);

const makeSelectListLoading = () => createSelector(
  store,
  ({ loading }) => loading,
);

const makeSelectTimerStarted = () => createSelector(
  store,
  ({ timerStarted }) => timerStarted,
);

const makeSelectTableHeight = () => createSelector(
  store,
  ({ tableHeight }) => tableHeight,
);

const makeSelectIsInitialState = () => createSelector(
  store,
  (state) => Object.is(state, initialState),
);

export {
  makeSelectItemList,
  makeSelectLocations,
  makeSelectMapOpened,
  makeSelectPagination,
  makeSelectTotalCount,
  makeSelectShowBooked,
  makeSelectUsedReport,
  makeSelectListLoading,
  makeSelectTableHeight,
  makeSelectReportStatus,
  makeSelectTimerStarted,
  makeSelectIsInitialState,
  makeSelectTitleSortValues,
  makeSelectAvailableReports,
  makeSelectTableTitleFilters,
};
